import Auth0Client from "@auth0/auth0-spa-js/dist/typings/Auth0Client"
import createAuth0Client, { Auth0ClientOptions, getIdTokenClaimsOptions, GetTokenSilentlyOptions, 
	GetTokenWithPopupOptions, GetUserOptions, IdToken, LogoutOptions, PopupConfigOptions, PopupLoginOptions, 
	RedirectLoginOptions, RedirectLoginResult } from "@auth0/auth0-spa-js"

/** Interface based on a console log of the auth result in plain javascript */
export interface IUser
{
    name?: string;
    given_name?: string;
    family_name?: string;
    middle_name?: string;
    nickname?: string;
    preferred_username?: string;
    profile?: string;
    picture?: string;
    website?: string;
    email?: string;
    email_verified?: boolean;
    gender?: string;
    birthdate?: string;
    zoneinfo?: string;
    locale?: string;
    phone_number?: string;
    phone_number_verified?: boolean;
    address?: string;
    updated_at?: string;
    sub?: string;
    [key: string]: any;
}

export interface IAuthenticationState
{
	/** Is the authorization setup complete? */
	setupCompleted: boolean,
	/** Is the user authenticated? */
	isAuthenticated: boolean,
	popupIsOpen: boolean,
	// user: IUser | null,
	user: IUser | undefined,
	token: IdToken | null
}
export let initialState: IAuthenticationState = {
	setupCompleted: false,
	popupIsOpen: false,
	isAuthenticated: false,
	// user: null,
	user: undefined,
	token: null
}

let _state: IAuthenticationState = { ...initialState };
let _auth0Client: Auth0Client | undefined = undefined;

export function getAuthenticationState(): IAuthenticationState
{
	if (!_state.setupCompleted) throw new Error("Can't request state if setup has not completed.");
	return _state;
}

export async function runAuthentication(
	clientOptions: Auth0ClientOptions,
	onRedirectCallback: (result?: RedirectLoginResult) => void,
	getUserOptions?: GetUserOptions,
	getTokenSilentlyOptions?: GetTokenSilentlyOptions
)
{
	if (_state.setupCompleted) return;

	_auth0Client = await createAuth0Client(clientOptions);
	// console.log('auth0Client', _auth0Client);

	if (
		window.location.search.includes("code=") &&
		window.location.search.includes("state=")
	) {
		const result = await _auth0Client.handleRedirectCallback();
		onRedirectCallback(result);
		// return;
	}

	_state.isAuthenticated = await _auth0Client.isAuthenticated();
	// console.log('Authenticated:', _state.isAuthenticated);

	if (_state.isAuthenticated) {
		_state.user = await _auth0Client.getUser(getUserOptions);
		// console.log('user', _state.user);

		if (_state.user) {
			_state.token = await _auth0Client.getTokenSilently(getTokenSilentlyOptions);
			// console.log('token', _state.token);
		}
	} else {

	}

	_state.setupCompleted = true;
}

function checkAuthClientSetup()
{
	if (!_auth0Client) throw new Error(
		'Auth client is not yet setup. Function call should be postponed.'
	);
}


let _isRedirecting = false;
export async function loginWithRedirect(options?: RedirectLoginOptions)
{
	// To prevent multiple redirects
	if (_isRedirecting) return;
	_isRedirecting = true;
	checkAuthClientSetup();
	await (_auth0Client as Auth0Client).loginWithRedirect(options);
	_isRedirecting = false;
}

// In case this is ever needed..
export async function loginWithPopup(params: { options?: PopupLoginOptions, config?: PopupConfigOptions } = {})
{
	checkAuthClientSetup();

	_state.popupIsOpen = true;
	try {
		await (_auth0Client as Auth0Client).loginWithPopup(params);
	} catch (error) {
		_state.user = undefined;
		_state.isAuthenticated = false;
		console.error(error);
	} finally {
		_state.popupIsOpen = false;
	}
	const user = await (_auth0Client as Auth0Client).getUser();
	_state.user = user;
	_state.isAuthenticated = true;
}

export async function getIdTokenClaims(options?: getIdTokenClaimsOptions)
{
	checkAuthClientSetup();
	return (_auth0Client as Auth0Client).getIdTokenClaims(options);
}

export async function getTokenWithPopup(options?: GetTokenWithPopupOptions, config?: PopupConfigOptions)
{
	checkAuthClientSetup();
	return (_auth0Client as Auth0Client).getTokenWithPopup(options, config);
}

export function logout(options?: LogoutOptions)
{
	checkAuthClientSetup();
	if (!_state.isAuthenticated) {
		throw new Error(
			'User is not authenticated. A call to logout by the user should not be possible.'
		);
	}

	(_auth0Client as Auth0Client).logout(options);
}


